import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencySymbol',
  standalone: false
})
export class CurrencySymbolPipe extends CurrencyPipe implements PipeTransform {
  override transform(value: string): any {
    const currencyValue = super.transform(0, value, 'symbol-narrow', '1.0-2');

    return currencyValue.replace(/[0-9]/g, '');
  }
}
